module.exports = __webpack_public_path__ + "static/media/tinder.5eb7b80d.JPG";